import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

require('./bootstrap');
require('slick-carousel');
require('./dialog_trigger');

document.addEventListener('show.bs.dropdown', function(e) {
    if (e.target.closest('header')) {
        document.querySelector('.fullBodyOverlay')?.classList.add('showed');
    }
});

document.addEventListener('shown.bs.dropdown', function(e) {
    if (e.target.closest('header')) {
        document.querySelector('.fullBodyOverlay')?.classList.add('showed');
    }
});

document.addEventListener('hidden.bs.dropdown', function(e) {
    if (e.target.closest('header')) {
        // Delay check to ensure layout updates complete
        setTimeout(() => {
            var header = e.target.closest('header');
            // Query for any open dropdown within the header
            var anyDropdownOpen = header.querySelector('.dropdown-menu.show') !== null;

            if (!anyDropdownOpen) {
                document.querySelector('.fullBodyOverlay')?.classList.remove('showed');
            }
        }, 20); // Delay added to allow Bootstrap's state to update
    }
});


(function ($) {
    $(document).ready(function () {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        // document.querySelector('.dropdown-menu').addEventListener('click', function (event) {
        //     event.stopPropagation();
        // });

        // Add class when any dropdown in header opens

        $('.dropdown-menu').on('click', function(e){
            var $toggle = $(e.target).closest('[data-bs-toggle="collapse"]');
            if ($toggle.length && $toggle.attr('aria-expanded') === 'true') {
                e.preventDefault();
                e.stopImmediatePropagation();
                if ($(window).width() < 767){
                    $(window.opera ? 'html' : 'html, body').animate({
                        scrollTop: 0
                    }, 'fast');
                }
                console.log('Prevented closing via open toggle', $toggle[0]);
                return false;
            }else
                e.stopPropagation();
        });

        // $('.dropdown-menu').on('click', function(e) {
        //     e.stopPropagation();
        // });


        $('body').on('click', 'a.select_item_ga_event',function(){
            var item = $(this).data('item');
            if(item)
                window.selectItem(item);
            
        });

        
        $('#go-to-top').on('click', function (e) {
            e.preventDefault();
            $(window.opera ? 'html' : 'html, body').animate({
                scrollTop: 0
            }, 'slow');
            return false;
        });

        if($('#dmv-writen-test-body').find('.challenge-bank-destroy').length){

            $('#dmv-writen-test-body').on('click', 'a.challenge-bank-destroy', function (e) {
                e.preventDefault();
                var $urlToPost = $(this).attr('href');
                $.ajax({
                    method: "post", url: $urlToPost, data: {'challengeBank': 1}, success: function (response) {
                        if($('#dmv-navigation').find('span#challenge-bank-count').length){

                            var currentErrors = $('#dmv-navigation').find('span#challenge-bank-count').text();
                            if(currentErrors){
                                $('#dmv-navigation').find('span#challenge-bank-count').text('0');
                            }   
                        }
                        if(response.redirectTo){
                            setTimeout(function () {
                                window.location.href = response.redirectTo;
                            }, 200);

                        }

                    }, error: function (response) {


                    }
                });

                return false;
            });
        }


        if ($('#slider-on-reviews-homepage').length > 0) {

            var winWidth = $(window).width();
            var containerWidth = $('#customer-reviews').find('> .container').width();
            var rightSide = parseInt((winWidth - containerWidth) / 2);


            var reWcontainerWidth = $('#no-wrap').closest('.container').width();
            var reWholderWidth = $('#no-wrap').closest('.reviews-holder-column').width();
            var reWrightSide = parseInt((winWidth - containerWidth) / 2);
            var reWflexedWidth = parseInt(reWholderWidth + rightSide + 165);


            if ($(window).width() > 991) $('#no-wrap').css({'width': reWflexedWidth + 'px'})


            setTimeout(function () {
                var topReviews = $('#slider-on-reviews-homepage').slick({
                    // lazyLoad: 'ondemand',
                    dots: false,
                    arrows: true,
                    infinite: true,
                    speed: 500,
                    autoplay: true,
                    autoplaySpeed: 9000,
                    slidesToShow: 2,
                    adaptiveHeight: true,
                    nextArrow: '#review-next',
                    prevArrow: '#review-prev',
                    responsive: [{
                        breakpoint: 991, settings: {
                            slidesToShow: 2, slidesToScroll: 2
                        }
                    }, {
                        breakpoint: 767, settings: {
                            slidesToShow: 1, slidesToScroll: 1
                        }
                    }]
                });

                if ($(window).width() > 991) {

                    $('#drivers-ed-coach-reviews').find('#review-next').css({'left': parseInt((reWflexedWidth / 2) - 52) + 'px'});
                    $('#drivers-ed-coach-reviews').find('#review-prev').css({'left': parseInt((reWflexedWidth / 2) - 92) + 'px'});
                }

                $('#slider-on-reviews-homepage').on('afterChange', function (event, slick) {
                    var currentDesktopSlide = $('#slider-on-reviews-homepage').slick('slickCurrentSlide');
                    $('#drivers-ed-coach-reviews').find('.counter span.active-review').text(parseInt(currentDesktopSlide + 1));

                });


            }, 400);

        }


        $('#question-form').on('click', 'a#next-section', function (e) {
            e.preventDefault();

            $(this).hide();
            var urlToPost = $(this).data('page');
            var nextPageUrl = $(this).attr('href');
            $.validateAnswers(urlToPost, nextPageUrl);

            return false;


        });


        $('#question-form').on('click', 'a#challenge-bank-recheck', function (e) {
            e.preventDefault();

            $(this).hide();

            $.challengeBankAnswers();

            return false;


        });


        if ($('#test-content').length) {
            $('#test-content').on('click', 'a.explanation-dropdown', function (e) {
                e.preventDefault();
                $(this).closest('.question-row').addClass('with-full-explanation')

                return false;
            })

            $('#test-progress').on('click', 'a.special-case-choose', function (e) {
                e.preventDefault();
                $(this).closest('.cookie-row').hide();
                var $urlToPost = $(this).attr('href');
                $.ajax({
                    method: "post", url: $urlToPost, data: {'cookieSet': 1}, success: function (response) {

                    }, error: function (response) {

                    }
                });

                return false;
            });

        }


        if ($('.series-description').length > 0) {
            $('.series-description').on('click', 'a.view-more-button', function (e) {
                e.preventDefault();
                var descriptionHolder = $(this).closest('.series-description');

                $(this).hide();
                $(descriptionHolder).find('.description-teaser').hide();
                $(descriptionHolder).find('.description-full-description').show();
                $(descriptionHolder).find('.series-passing-grade').addClass('flexed');


                return false;
            })

            if ($('#series-explanation-box').length > 0) {
                $('#series-explanation-box').on('click', '#instructions-tab', function (e) {
                    e.preventDefault();
                    if ($(this).hasClass('opened')) {
                        $(this).removeClass('opened');
                        $('#series-explanation-box').find('#series-explanation').fadeOut(400);
                        $('#series-explanation-box').find('#series-description').fadeOut(400);
                    } else {
                        $(this).addClass('opened');
                        $('#series-explanation-box').find('#series-explanation').fadeIn(400);
                        $('#series-explanation-box').find('#series-description').fadeIn(400);
                    }

                    return false;
                })

            }
        }


        if ($('.rating-holder').length > 0) {

            $('.rating-holder').on('change', 'input.rb', function () {
                var stars = $(this).val(), serie_id = $(this).closest('.rating-holder').data('serie');

                $.ajax({
                    async: true, url: '/rate-us', method: 'post', data: {
                        serie_id: serie_id, stars: stars,
                    }, success: function (data) {
                        $('.rating-holder').find('input').prop('disabled', true);

                        if (data.status) {
                            $('.rating-holder').find('.star-text-holder p').hide();
                            $('.rating-holder').find('.star-text-holder p.ratting-success').show();
                        } else {
                            $('.rating-holder').find('.star-text-holder p').hide();
                            $('.rating-holder').find('.star-text-holder p.ratting-error').show();
                        }
                    }, error: function () {
                        $('.rating-holder').find('input').prop('disabled', true);
                        $('.rating-holder').find('.star-text-holder p').hide();
                        $('.rating-holder').find('.star-text-holder p.ratting-error').show();
                    }
                });


            });


        }

        if ($('.search-btn-holder').length > 0) {
            $('.search-btn-holder').on('click', 'input', function () {
                var closestHolder = $(this).closest('.button-item '),
                    topHolder = $(closestHolder).closest('.columns-blocks');


                $(topHolder).find('.active').removeClass('active');
                $(closestHolder).addClass('active');

            });
        }

        if ($('#test-progress').length > 0) {
            $('#test-progress').on('click', 'a#showJuniorContentUp', function () {
                $('#test-progress').find('.cookie-row .slide-description').fadeIn(400);
                $(this).hide();

                return false;

            });
        }


        if ($('#samples-slider-carousel').length > 0) {

            var samplesSlick = $('#samples-slider-carousel').slick({
                                autoplay: true,
                                autoplaySpeed: 5000,
                                centerMode: false,
                                centerPadding: '0px',
                                slidesToShow: 3,
                                infinity: true,
                                nextArrow: '#sample-next',
                                prevArrow: '#sample-prev',
                                responsive: [
                                    {
                                        breakpoint: 1140,
                                        settings: {
                                            autoplay: true,
                                            arrows: true,
                                            centerMode: false,
                                            centerPadding: '55px',
                                            slidesToShow: 2
                                        }
                                    },
                                    {
                                    breakpoint: 990,
                                        settings: {
                                            autoplay: true,
                                            arrows: false,
                                            centerMode: false,
                                            centerPadding: '15px',
                                            slidesToShow: 2
                                        }
                                    },
                                    {
                                    breakpoint: 782,
                                        settings: {
                                            autoplay: true,
                                            arrows: false,
                                            centerMode: false,
                                            centerPadding: '95px',
                                            slidesToShow: 2
                                        }
                                    },
                                    {
                                    breakpoint: 700,
                                        settings: {
                                            autoplay: true,
                                            arrows: false,
                                            centerMode: true,
                                            centerPadding: '45px',
                                            slidesToShow: 1
                                        }
                                    },
                                    {
                                        breakpoint: 360,
                                        settings: {
                                            autoplay: true,
                                            arrows: false,
                                            centerMode: true,
                                            centerPadding: '25px',
                                            slidesToShow: 1
                                        }
                                    },
                                ]
                            });





            var sampleImageShow = 0;
            $('#samples-slider-carousel').on('click', 'a.bootstrap-modal-show',function(e){
                e.preventDefault();
                $('#sample-modal').find('img').hide().removeClass('showed');
                sampleImageShow = $(this).data('image');

                if(sampleImageShow){
                    $('#sample-modal').find('#sample-image-'+sampleImageShow).fadeIn(200).addClass('showed');
                    $('#sample-modal').modal('show')
                }
                return false;
            })

            $('#sample-modal').on('click', 'a#sample-modal-prev',function(e){
                e.preventDefault();
                $('#sample-modal').find('img').hide().removeClass('showed');

                if(sampleImageShow == 1)
                    sampleImageShow = 4;
                else
                    sampleImageShow--;

                $('#sample-modal').find('#sample-image-'+sampleImageShow).fadeIn(200).addClass('showed');

                return false;
            })

            $('#sample-modal').on('click', 'a#sample-modal-next',function(e){
                e.preventDefault();
                $('#sample-modal').find('img').hide().removeClass('showed');
                if(sampleImageShow == 4)
                    sampleImageShow = 1;
                else
                    sampleImageShow++;

                $('#sample-modal').find('#sample-image-'+sampleImageShow).fadeIn(200).addClass('showed');

                return false;
            })

        }




    });
})(jQuery);

$.showOverlay = function($el = 'body'){
    $($el).addClass('showed');
}

$.removeOverlay = function($el = 'body'){ 
    $($el).removeClass('showed');
}


$.challengeBankAnswers = function ($el = '#questions-holder', $responseHolder = '#test-progress') {

    var questionsWrappers = $($el).find('.question-row'), answers = {}, firstErrorWrapper = false, firstError = false;

    $.each(questionsWrappers, function (i, k) {
        $(k).addClass('validated');
        $(k).find('.form-check-input').prop('disabled', true);
        var answer = $(k).find('input:checked'), questionNo = $(k).data('number'), questionId = $(k).data('id'),
            orderNo = $(k).data('order'), option = $(k).data('option'), questionRes = $(k).data('value'),
            inputHtml = '';

        if ($(answer).length > 1) answer = $(k).find('input:checked').first();

        var validInput = $(k).find('input[value="' + questionRes + '"]');

        if ($(answer).length > 0) {
            $(answer).addClass('chosen');
            if ($(answer).val() == questionRes) {
                answers[questionNo] = {
                    'status': 1, 'answer': $(answer).val(), 'option': option, 'id': questionId, 'order': orderNo
                };
                $(answer).closest('.form-check').removeClass('not-related-wrapper').addClass('correct-wrapper');
                $(answer).removeClass('not-related').addClass('correct');
            } else {
                answers[questionNo] = {
                    'status': 0, 'answer': $(answer).val(), 'option': option, 'id': questionId, 'order': orderNo
                };
                $(answer).closest('.form-check').removeClass('not-related-wrapper').addClass('error-wrapper');
                $(answer).removeClass('not-related').addClass('error');
                if (!firstErrorWrapper) firstErrorWrapper = $(k);
            }

        } else {
            answers[questionNo] = {'status': 0, 'answer': 0, 'option': option, 'id': questionId, 'order': orderNo};
            if (!firstErrorWrapper) firstErrorWrapper = $(k);
        }

        if ($(validInput).length > 0) {
            $(validInput).closest('.form-check').removeClass('not-related-wrapper').addClass('correct-wrapper');
            $(validInput).removeClass('not-related').addClass('correct');
        }

    });

    setTimeout(function () {
    

        $('html, body').animate({
            scrollTop: $("#main-test-content").offset().top
        }, 800, function () {
           
            $($el).addClass('validated');
            $.each(answers, function (i, k) {
                var qId = k.id;
                var wrapper = $($el).find('.question-row[data-id="' + qId + '"]');
                $(wrapper).addClass('with-full-explanation');

            });

        });


    }, 200);

}


$.validateAnswers = function ($urlToPost = false, $nextPageUrl = false, $el = '#questions-holder', $responseHolder = '#test-progress') {

    var questionsWrappers = $($el).find('.question-row'), answers = {}, firstErrorWrapper = false, firstError = false;

    $.each(questionsWrappers, function (i, k) {
        $(k).addClass('validated');
        $(k).find('.form-check-input').prop('disabled', true);
        var answer = $(k).find('input:checked'), questionNo = $(k).data('number'), questionId = $(k).data('id'),
            orderNo = $(k).data('order'), option = $(k).data('option'), questionRes = $(k).data('value'),
            inputHtml = '';

        if ($(answer).length > 1) answer = $(k).find('input:checked').first();

        var validInput = $(k).find('input[value="' + questionRes + '"]');

        if ($(answer).length > 0) {
            $(answer).addClass('chosen');
            if ($(answer).val() == questionRes) {
                answers[questionNo] = {
                    'status': 1, 'answer': $(answer).val(), 'option': option, 'id': questionId, 'order': orderNo
                };
                $(answer).closest('.form-check').removeClass('not-related-wrapper').addClass('correct-wrapper');
                $(answer).removeClass('not-related').addClass('correct');
            } else {
                answers[questionNo] = {
                    'status': 0, 'answer': $(answer).val(), 'option': option, 'id': questionId, 'order': orderNo
                };
                $(answer).closest('.form-check').removeClass('not-related-wrapper').addClass('error-wrapper');
                $(answer).removeClass('not-related').addClass('error');
                if (!firstErrorWrapper) firstErrorWrapper = $(k);
            }

        } else {
            answers[questionNo] = {'status': 0, 'answer': 0, 'option': option, 'id': questionId, 'order': orderNo};
            if (!firstErrorWrapper) firstErrorWrapper = $(k);
        }

        if ($(validInput).length > 0) {
            $(validInput).closest('.form-check').removeClass('not-related-wrapper').addClass('correct-wrapper');
            $(validInput).removeClass('not-related').addClass('correct');
        }

    });

    setTimeout(function () {
        if ($(answers).length > 0 && $urlToPost && $nextPageUrl) {
            $.ajax({
                method: "post",
                url: $urlToPost,
                data: {'answer': answers, 'nextUrl': $nextPageUrl},
                success: function (response) {
                    if (response) {
                        var challengeBankCount = 0;
                        $($responseHolder).html(response).promise().done(function () {
                            $('html, body').animate({
                                scrollTop: $("#main-test-content").offset().top
                            }, 1000, function () {
                               
                                $($el).addClass('validated');
                                setTimeout(function () {
                                    $($responseHolder).removeClass('d-none');

                                    if ($($responseHolder).find('.user-pregress-box').length) {
                                        $('#series-explanation-box').find('.series-progress').html($($responseHolder).find('.user-pregress-box'));
                                    }                                


                                }, 600);

                            });

                            setTimeout(function () {
                                $.each(answers, function (i, k) {
                                    if (k.status) {

                                    } else {

                                        var qId = k.id;
                                        var wrapper = $($el).find('.question-row[data-id="' + qId + '"]');
                                        $(wrapper).addClass('with-full-explanation');
                                        $(wrapper).find('.explanation-row > a.explanation-dropdown').hide();

                                        if(['A', 'B', 'C', 'D'].includes(k.answer)){
                                            challengeBankCount++;
                                            if(firstError){
                                                $($('#test-progress').find('.challenge-bank-link')).clone().appendTo($(wrapper))
                                            }
                                        }

                                        if (!firstError && $(firstErrorWrapper).length) {
                                            firstError = true;
                                            $($('#test-progress').find('#study-tip-banner')).appendTo($(firstErrorWrapper)).promise().done(function () {
                                                if ($('#study-tip-slider-carousel').length > 0) {

                                                    setTimeout(function () {

                                                        var studyTipSlick = $('#study-tip-slider-carousel').slick({
                                                                            autoplay: true,
                                                                            autoplaySpeed: 5000,
                                                                            centerMode: false,
                                                                            centerPadding: '0px',
                                                                            slidesToShow: 3,
                                                                            infinity: true,
                                                                            nextArrow: '#study-tip-next',
                                                                            prevArrow: '#study-tip-prev',
                                                                            arrows: true                                                                      
                                                                        });

                                                        var studyTipImageShow = 0;
                                                        $('#study-tip-slider-carousel').on('click', 'a.bootstrap-modal-show',function(e){
                                                            e.preventDefault();
                                                            $('#study-tip-modal').find('img').hide().removeClass('showed');
                                                            studyTipImageShow = $(this).data('image');

                                                            if(studyTipImageShow){
                                                                $('#study-tip-modal').find('#study-tip-image-'+studyTipImageShow).fadeIn(200).addClass('showed');
                                                                $('#study-tip-modal').modal('show')
                                                            }
                                                            return false;
                                                        })

                                                        $('#study-tip-modal').on('click', 'a#study-tip-modal-prev',function(e){
                                                            e.preventDefault();
                                                            $('#study-tip-modal').find('img').hide().removeClass('showed');

                                                            if(studyTipImageShow == 1)
                                                                studyTipImageShow = 4;
                                                            else
                                                                studyTipImageShow--;

                                                            $('#study-tip-modal').find('#study-tip-image-'+studyTipImageShow).fadeIn(200).addClass('showed');

                                                            return false;
                                                        })

                                                        $('#study-tip-modal').on('click', 'a#study-tip-modal-next',function(e){
                                                            e.preventDefault();
                                                            $('#study-tip-modal').find('img').hide().removeClass('showed');
                                                            if(studyTipImageShow == 4)
                                                                studyTipImageShow = 1;
                                                            else
                                                                studyTipImageShow++;

                                                            $('#study-tip-modal').find('#study-tip-image-'+studyTipImageShow).fadeIn(200).addClass('showed');

                                                            return false;
                                                        })

                                                    }, 400);

                                                }

                                            });


                                            $($('#test-progress').find('#study-tip-modal')).appendTo($('body')).promise().done(function () {


                                            });


                                        }

                                    }

                                });

                                if(challengeBankCount && $('#dmv-navigation').find('span#challenge-bank-count').length){

                                    var currentErrors = $('#dmv-navigation').find('span#challenge-bank-count').text();
                                    if(currentErrors){
                                        setTimeout(function () {
                                            var newCount = parseInt(currentErrors)+challengeBankCount;
                                            if(newCount) 
                                                $('#dmv-navigation').find('span#challenge-bank-count').text(newCount);

                                        }, 400);
                                    }   
                                }



                                var hasItem = $('#test-content').find('.study-tip-button a.select_item_ga_event');
                                 if($(hasItem).length){
                                    $.each(hasItem, function (i, k) {
                                        var item = $(k).data('item');
                                        if(item)
                                            window.viewItemList(item);

                                    });
 
                                }

                            }, 800);

                            if($($responseHolder).find('#instructions-tip-end-test').length)
                                $($responseHolder).addClass('no-sticky');


                        });

                    }

                },
                error: function (response) {

                    if (response.responseJSON && response.responseJSON.message) {

                        $($responseHolder).html('<div class="error failed progress-row"><mark>' + response.responseJSON.message + '</mark></div>').promise().done(function () {
                            $('html, body').animate({
                                scrollTop: $("#main-test-content").offset().top
                            }, 1000, function () {
                                $($el).addClass('validated');
                                setTimeout(function () {
                                    $($responseHolder).removeClass('d-none');

                                }, 400);

                            });
                        });


                    }

                    setTimeout(function () {
                        window.location.reload(true);
                    }, 3000);

                    // window.location.reload(true);
                }
            });
        } else {
            setTimeout(function () {
                window.location.reload(true);
            }, 3000);
        }
    }, 100);


}


